import TimeExpiredIcon from 'assets/ver2/icons/time-expired-icon.svg';
import useLang from 'hooks/useLang';
import { functionUtils } from 'utils';
import Popup from './popup';

const ReferralLinkExpiredModal = ({ isShow, action }) => {
  const { t } = useLang();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
  };

  return (
    <Popup
      isOpen={isShow}
      imageSrc={TimeExpiredIcon}
      imagesStyles={{
        width: '75px',
        height: '100%',
      }}
      text={''}
      content={t('popup_referral_link_expired')}
      buttonLabel2={t('button_ok')}
      onClick={handleOnClick}
      isBackdropOverlap={true}
      zIndexBackdropOverlap={1055}
    />
  );
};

export default ReferralLinkExpiredModal;
